import ActivityTab from "@/modules/lead-page/new/components/activity/activity-tab";
import { TrackActivityProvider } from "../../contexts/track-activity.context";
import { Track } from "../../types";
import { PROPERTY_TRACKS } from "../../utils";
import AddTrackComment from "./add-comment";
import AddBrokerShowing from "./add-broker-showing";
import { ActivityScrollProvider } from "@/modules/lead-page/new/context/activity-scroll-context";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";

export default function PropertyActivity({ track }: { track: Track }) {
  const canLogBrokerShowing =
    track.trackType?.name === PROPERTY_TRACKS.RENTAL &&
    track.property?.propertyFinishing?.rentalTag === "longTerm";

  return (
    <TrackActivityProvider trackUId={track.uid}>
      <ActivityScrollProvider>
        <ActivityTab
          isHeaderCollapsed={false}
          addComment={
            <>
              {canLogBrokerShowing && (
                <PermissionGuard
                  permissions={[
                    {
                      name: PermissionsEnum.ADD_TRACK_COMMENT,
                      level: PermissionLevel.WRITE,
                    },
                  ]}
                >
                  <AddBrokerShowing trackUId={track.uid} />
                </PermissionGuard>
              )}
              <PermissionGuard
                permissions={[
                  {
                    name: PermissionsEnum.ADD_TRACK_COMMENT,
                    level: PermissionLevel.WRITE,
                  },
                ]}
              >
                <AddTrackComment trackUId={track.uid} />
              </PermissionGuard>
            </>
          }
        />
      </ActivityScrollProvider>
    </TrackActivityProvider>
  );
}
